// extracted by mini-css-extract-plugin
module.exports = {"titleTruncate":"TruncatedHeaderTitle_titleTruncate__5Gzw7"};